var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn', _vm.isOneOfExpectedAspectType ? `btn_${this.aspectType}` : `btn_${_vm.defaultAspect}`],style:(_vm.cssProps),attrs:{"id":this.buttonId,"data-testid":"sbx-pcc_button"},on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick()}}},[_c('span',[_vm._v(" "+_vm._s(this.buttonTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }